import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_CONFIG_ITEM } from './config-item.gql';
import { GetConfigItem } from './__generated__/GetConfigItem';

export function LightTouchReports() {
  const [queryLightTouchReports] = useCampfireLazyQuery<GetConfigItem, { key: string }>(GET_CONFIG_ITEM);
  const [lightTouchReports, setLightTouchReports] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryLightTouchReports({ variables: { key: 'light-touch-reports' } }).then((response) =>
      setLightTouchReports(
        response.data?.vm.configItem?.configItemValue?.flagValue ?? response.data?.vm.configItem?.defaultValue
      )
    );
  }, []);

  const saveLightTouchReports = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    saveLightTouchReports
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: 'light-touch-reports',
          value: !lightTouchReports,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setLightTouchReports(!lightTouchReports);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(lightTouchReports)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'light touch reports' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Light Touch Reports
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            {
              'When enabled, activity reports will not be flagged as incomplete if a roster was never published for that date.'
            }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
